module.exports = __webpack_public_path__ + "static/img/secret-stuff-gone.c02cd23.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/secret-stuff-gone.gif
// module id = 5nCL
// module chunks = 1